const bom = {
  bomType: "Bom type",
  bomCode: 'Master part code',
  bomName: 'Master part name',
  bomModal: 'Material specification',
  bomUnit: 'Unit of measurement',
  bomVersion: 'Version number',
  bomVersionDesc: 'Version description',
  bomVersionDate: 'Version date',
  bomStatus: 'Bom status',
  approvaler: 'Approval',
  createDate: 'File creation date',
  creator: 'File creator',
  updateDate: 'Modification date',
  updater: 'Modifier',

  itemLevel: 'Level',
  itemCode: 'Sub-part code',
  itemName: 'Sub-part name',
  itemModal: 'Sub-part specification',
  itemUnit: 'Unit of measurement',
  itemBase: 'Basic quantity',
  itemBaseQuantity: 'Basic quantity',
  itemAttritionRate: 'Sub-component loss rate',
  itemUseQuantity: 'Usage quantity',
  itemEffectiveDate: 'Effective date',
  itemExpiringDate: 'Expiration date',
  itemReMark: 'Remarks',
  itemLocators: 'Locator 1',
  itemExtraRate: 'Loss rate',

  itemLevelInfo: 'Level {{ level }}',
  itemReq: 'Alternative material',

  plBaseUnit: 'Please enter the basic quantity',
  plBaseQuantity: 'Please enter the basic quantity',
  plAttritionRate: 'Please enter the sub-component loss rate',
  plUseQuantity: 'Please enter the usage quantity',
  plRemark: 'Please enter the remarks',
  plLocators: 'Please enter the locator 1',

  importError: 'Import failed',
  bomUpload: 'Upload BOM table',
  bomDetail: 'BOM Details',
  closeTip: "The demand list has not been generated yet. Are you sure you want to close it?",
  errTip: "Please check the data",
  errTipdesc: "At least one material's required quantity must be greater than 0 to continue",
  stockNum: "Inventory quantity",
  reqManage: "Demand List Management",
  preStock: "Pre-Outbound Stock Quantity",
  preInStock: "Pre-Inbound Stock Quantity",
  useStock: "Available Stock Quantity",
  prePurNum: "Required Purchase Quantity (0 for regular items)",
  prePurNum_1: "Required Purchase Quantity",
  preOutNum: "Pre-Outbound Quantity (no pre-outbound for regular items)",
  preOutNum_1: "Pre-Outbound Quantity",
  matchErr: "Inventory Matching Failed",
  noSaleOrderOrProduct: "The demand list has no parent item, so production quantity picking cannot be performed",
  bomUsageMatchErr: "BOM matching failed, so production quantity picking cannot be performed",
  confirmAdd: "Add Demand List (Pre-Outbound Order)",
  inventorySucc: "Pre-outbound order: {{number}} has been generated, outbound location has been assigned",
  saveTemp: "Save template?",
  merge: "Materials: {{codes}} are duplicated; their required quantities have been summed",
  editBom: "Edit BOM Table",
  addBom: "Add BOM Table",
  materialControlTemplate: "Material Control Requirements Template",
  originBom: "Main Material",
  calcErr: "Combined material quantity allocation error!",
  calcData: "Requirement: Main material required quantity + Sum of all substitute material required quantities = Total standard quantity of main material",
  allocated: "Allocated Stock Quantity",
  expandAll: "Expand All",
  collapseAll: "Collapse All",
  parseBonErr: "BOM parsing failed",
  addTip: "The following materials do not exist in the system. Do you need to add them?",
  notItem: "The following materials do not exist in the system and will not generate demand order data",
  fileErr: "Failed to retrieve BOM attachment information",
  facStock: "Production Line Stock",
  facStockAlloc: "Used Production Line Stock",
  useFactoryCount: "Production Line Stock Usage",
  realStockNum: "On-hand Stock Quantity",
  realPreStock: "On-hand Pre-outbound Stock Quantity",
  realUseStock: "Available On-hand Stock Quantity",
  realAllocated: "Used On-hand Stock Quantity",
  bomNull: "No available BOM data source",
  bomNullTip: "At least one of the following must be provided: sales order BOM file, template, or system BOM data",
};

export default bom;
